import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Leaf, Lock, User as UserIcon } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { useToast } from '../../hooks/use-toast';

const Login = () => {
  const { user, login, loading } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const { toast } = useToast();

  if (!loading && user) return <Navigate to="/admin/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(username, password);
      navigate('/admin/dashboard');
    } catch (err) {
      toast({ title: 'Login failed', description: 'Invalid username or password.', variant: 'destructive' });
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-forest-dark px-5">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <span className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-forest-light mb-4"><Leaf className="w-7 h-7 text-gold-light" strokeWidth={1.6} /></span>
          <h1 className="font-display text-3xl text-white">Owner Portal</h1>
          <p className="text-cream/60 text-sm mt-2">Sign in to manage the garden website.</p>
        </div>
        <form onSubmit={submit} className="bg-cream rounded-2xl p-8 shadow-2xl">
          <label className="block text-sm font-600 text-forest mb-2">Username</label>
          <div className="relative mb-5">
            <UserIcon className="w-4 h-4 text-ink/40 absolute left-3.5 top-1/2 -translate-y-1/2" />
            <input value={username} onChange={(e) => setUsername(e.target.value)} required className="w-full pl-10 pr-4 py-3 rounded-lg border border-sand focus:border-gold focus:outline-none text-sm" placeholder="owner" />
          </div>
          <label className="block text-sm font-600 text-forest mb-2">Password</label>
          <div className="relative mb-6">
            <Lock className="w-4 h-4 text-ink/40 absolute left-3.5 top-1/2 -translate-y-1/2" />
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="w-full pl-10 pr-4 py-3 rounded-lg border border-sand focus:border-gold focus:outline-none text-sm" placeholder="••••••••" />
          </div>
          <button type="submit" disabled={busy} className="w-full py-3.5 rounded-full bg-gold text-white font-600 hover:bg-gold-light transition-colors disabled:opacity-60">{busy ? 'Signing in...' : 'Sign In'}</button>
        </form>
        <p className="text-center text-cream/40 text-xs mt-6">Authorized personnel only.</p>
      </div>
    </div>
  );
};

export default Login;
